import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: shopifyGenericDefaults.Widgets.map((widget) =>
    widget.name === 'VerifyFitment' ? { ...widget, dropdownsWithProductId: true } : widget,
  ),
};
